import { VerificationCodeType } from "@overmap-ai/common"
import { getRouteApi } from "@tanstack/react-router"
import { memo } from "react"

import { MapBackgroundContainer } from "../../components/MapBackgroundContainer/MapBackgroundContainer"
import { ApplicationInviteForm } from "./ApplicationInviteForm"

const routeApi = getRouteApi("/verify-email")

export const EmailVerificationView = memo(() => {
	const { code } = routeApi.useSearch()
	const { verification_type } = routeApi.useLoaderData()

	const isJoinAppView = verification_type === VerificationCodeType.APPLICATION_INVITE

	return (
		<MapBackgroundContainer>{isJoinAppView ? <ApplicationInviteForm code={code} /> : null}</MapBackgroundContainer>
	)
})

EmailVerificationView.displayName = "EmailVerificationView"
